import controller from './promocode-redirect.controller';

export default {
  controller,
  template: require('./promocode-redirect.html')
};


// WEBPACK FOOTER //
// src/app/components/promocode-redirect/promocode-redirect.component.ts